import { debugLsidEvent, randomLogId } from 'root/datadog/datadogLogs';

export function waitForElementToBeRemoved(selector: string, logId?: string): Promise<void> {
  if (!logId) logId = randomLogId();
  debugLsidEvent('waitForElementToBeRemoved - start', { selector, logId });

  return new Promise((resolve) => {
    if (!document.querySelector(selector)) {
      debugLsidEvent('waitForElementToBeRemoved - end - not found', {
        selector,
        logId,
      });
      return resolve(undefined);
    }

    const observer = new MutationObserver(() => {
      if (!document.querySelector(selector)) {
        debugLsidEvent('waitForElementToBeRemoved - end - removed', {
          selector,
          logId,
        });
        resolve(undefined);
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
}
